import { useCallback } from "react";

import { logEvent } from "@snapchat/blizzard";
import { useRecoilValue } from "recoil";

import { blizzardInitializedAtom, sessionIdAtom } from "../../shared/state";
import { type BlizzardEventData, createBlizzardEvent } from "../models";

export const useBlizzardEvents = (): { sendBlizzardEvent: (data: BlizzardEventData) => void } => {
    const sessionId = useRecoilValue(sessionIdAtom);
    const blizzardInitialized = useRecoilValue(blizzardInitializedAtom);

    const sendBlizzardEvent = useCallback(
        (data: BlizzardEventData) => {
            const eventData = createBlizzardEvent(data, sessionId);

            if (blizzardInitialized) {
                logEvent(eventData);
            }
        },
        [blizzardInitialized, sessionId],
    );

    return { sendBlizzardEvent };
};
